import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import LabelBadge from '~components/Common/LabelBadge';

const COMPACT_DOT_SIZE_IN_PX = 6;

interface PrevailingWageBadgeProps {
  compact?: boolean;
}

export default function PrevailingWageBadge({
  compact = false,
}: PrevailingWageBadgeProps) {
  if (compact) {
    return (
      <Box
        data-test-id="prevailing-wage-badge"
        sx={(theme) => ({
          alignItems: 'center',
          bgcolor: alpha(theme.brandV2.colors.treadBlue, 0.08),
          borderRadius: '4px',
          display: 'inline-flex',
          gap: 0.5,
          px: 0.75,
          py: 0.25,
        })}
      >
        <Box
          sx={(theme) => ({
            bgcolor: theme.brandV2.colors.treadBlue,
            borderRadius: '50%',
            flexShrink: 0,
            height: COMPACT_DOT_SIZE_IN_PX,
            width: COMPACT_DOT_SIZE_IN_PX,
          })}
        />
        <Typography
          component="span"
          sx={{
            color: 'text.primary',
            fontSize: '10px',
            fontWeight: 400,
            lineHeight: '14px',
          }}
        >
          {t('common.prevailing_wage_badge')}
        </Typography>
      </Box>
    );
  }

  return <LabelBadge label={t('common.prevailing_wage_badge')} />;
}
